export default "__VITE_ASSET__c362ec1a__"